// PlannerDaterange Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import SvgIcon from '../../common/svgicon/svgicon.jsx'

class PlannerDateRange extends Component {
  static get propTypes () {
    return {
      showHour: PropTypes.bool,
      canEdit: PropTypes.bool,
      isEmpty: PropTypes.bool,
      isWeekMode: PropTypes.bool,
      showAvailableInfo: PropTypes.bool,
      showPlannedInfo: PropTypes.bool,
      items: PropTypes.array,
      onChange: PropTypes.func,
      onShowHour: PropTypes.func,
      isUserMode: PropTypes.bool,
      canEditItem: PropTypes.bool,
      showMarker: PropTypes.bool,
      showGanttBar: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      showHour: false,
      canEdit: false,
      isEmpty: false,
      isWeekMode: false,
      showAvailableInfo: false,
      showPlannedInfo: false,
      items: [],
      onChange: null,
      onShowHour: null,
      isUserMode: false,
      canEditItem: false,
      showMarker: false,
      showGanttBar: false
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const {
      showHour,
      canEdit,
      isEmpty,
      isWeekMode,
      showAvailableInfo,
      items,
      showPlannedInfo,
      isUserMode,
      canEditItem,
      showMarker,
      showGanttBar
    } = this.props
    if (
      !_.isEqual(items, nextProps.items) ||
      showHour !== nextProps.showHour ||
      canEdit !== nextProps.canEdit ||
      isEmpty !== nextProps.isEmpty ||
      isWeekMode !== nextProps.isWeekMode ||
      showAvailableInfo !== nextProps.showAvailableInfo ||
      showPlannedInfo !== nextProps.showPlannedInfo ||
      isUserMode !== nextProps.isUserMode ||
      canEditItem !== nextProps.canEditItem ||
      showMarker !== nextProps.showMarker ||
      showGanttBar !== nextProps.showGanttBar
    ) {
      return true
    }
    return false
  }

  render () {
    const { showHour, canEdit, isEmpty, isWeekMode, items } = this.props
    const canEditItem = canEdit && !isWeekMode

    const _className = classnames('planner-daterange', {
      hidehour: !showHour,
      hasedit: canEditItem,
      weekmode: isWeekMode
    })

    if (isWeekMode) {
      const totalWeeks = Math.floor(items.length / 7)

      return _.range(totalWeeks).map(idx => {
        return (
          <div className={_className} key={idx}>
            {items
              .slice(idx * 7, idx * 7 + 7)
              .map(item =>
                this._renderDayItem(item, canEditItem, isEmpty, isWeekMode)
              )}
          </div>
        )
      })
    }

    return (
      <div className={_className}>
        {items.map((item, itemIdx) =>
          this._renderDayItem(item, canEditItem, isEmpty, isWeekMode, itemIdx)
        )}
      </div>
    )
  }

  _renderDayItem (item, canEditItem, isEmpty, isWeekMode, itemIdx) {
    const {
      showAvailableInfo,
      showPlannedInfo,
      showMarker,
      showGanttBar
    } = this.props
    const showTitle =
      canEditItem || (!isEmpty && (showAvailableInfo || showPlannedInfo))
    const isStartAndEnd = !!(
      item.position !== 'start' &&
      item.position === 'middle' &&
      item.position !== 'end'
    )
    return (
      <div
        key={item.date}
        className={classnames('item', {
          [item.position]: item.position && showPlannedInfo,
          hideavailable:
            !showAvailableInfo && !(item.position && showPlannedInfo),
          start: !!(
            showGanttBar &&
            item.position === 'start' &&
            item.position !== 'middle' &&
            item.position !== 'end'
          ),
          middle: !!(
            showGanttBar &&
            item.position !== 'start' &&
            item.position === 'middle' &&
            item.position !== 'end'
          ),
          end: !!(
            showGanttBar &&
            item.position !== 'start' &&
            item.position !== 'middle' &&
            item.position === 'end'
          )
        })}
      >
        {!item.disabled && (
          <>
            {item.isDueDate && <div className='duedate' />}
            {item.position && showMarker && (
              <div className={`${!isStartAndEnd ? 'duration' : ''}`} />
            )}
            {canEditItem && (
              <div
                className='action actionplus'
                onClick={this._onResetHour.bind(this, item)}
              >
                <SvgIcon name='allday' size='12' className='iconcont' />
              </div>
            )}
            {showTitle && this._renderHour(isWeekMode, item, itemIdx)}
            {canEditItem && (
              <div
                className='action actionminus'
                onClick={this._onChangeHour.bind(this, item, -1)}
              >
                -
              </div>
            )}
            {!isEmpty && <div className='backcont' />}
          </>
        )}
      </div>
    )
  }

  _renderHour (isWeekMode, item, itemIdx) {
    const {
      onShowHour,
      showAvailableInfo,
      showPlannedInfo,
      isUserMode
    } = this.props
    const availableHours = showAvailableInfo ? item.availableHours || 0 : ''

    if (isUserMode) {
      return (
        <div className='title'>
          {(showAvailableInfo || showPlannedInfo) && (
            <span className='hour'>
              {isWeekMode
                ? ''
                : showPlannedInfo
                  ? item.noHours || availableHours
                  : availableHours}
            </span>
          )}
        </div>
      )
    }

    return (
      <div
        className={`title${item.noHours ? ' highlight' : ''}`}
        onClick={onShowHour ? this._onShowHour.bind(this, item, itemIdx) : null}
      >
        {showAvailableInfo && showPlannedInfo ? (
          <span className='hour'>
            {isWeekMode ? '' : item.noHours || availableHours}
          </span>
        ) : showAvailableInfo ? (
          <>
            <span className='hour available'>
              {isWeekMode ? '' : availableHours}
            </span>
            <span className='hour planned'>
              {isWeekMode ? '' : item.noHours || availableHours}
            </span>
          </>
        ) : showPlannedInfo ? (
          <span className='hour'>{isWeekMode ? '' : item.noHours}</span>
        ) : (
          <span className='hour planned'>{isWeekMode ? '' : item.noHours}</span>
        )}
      </div>
    )
  }

  /* Event handlers */
  _onResetHour (item) {
    const { onChange } = this.props

    // Calculate the remaining duration
    const prevNoHours = item.noHours
    let remainingDuration =
      item.duration / 60 - item.scheduledHours + item.noHours
    if (remainingDuration < 0) {
      remainingDuration = 0
    }

    /*
    console.log('ITEM Duration', item.duration);
    console.log('ITEM noHours', item.noHours);
    console.log('ITEM scheduledHours', item.scheduledHours);
    console.log('ITEM remainingDuration', remainingDuration);
    */

    const noHours = Math.round(
      item.availableHours < remainingDuration
        ? item.availableHours
        : remainingDuration
    )

    // console.log('ITEM noHours', noHours);
    item.noHours = noHours
    this.setState({ dataDate: new Date() })

    if (onChange) {
      item.scheduledHours += noHours - prevNoHours
      onChange(item.date, noHours)
    }
  }

  _onChangeHour (item, incr) {
    const { onChange } = this.props
    const prevNoHours = item.noHours
    let noHours = item.noHours

    noHours += incr
    if (noHours < 0 || noHours > 24) {
      noHours = 0
    }

    item.noHours = noHours
    this.setState({ dataDate: new Date() })

    if (onChange) {
      item.scheduledHours += noHours - prevNoHours
      onChange(item.date, noHours)
    }
  }

  _onShowHour (item, itemIdx) {
    const { showAvailableInfo, onShowHour, onChange } = this.props

    if (onChange && item.noHours <= 0) {
      const prevNoHours = item.noHours
      item.noHours = showAvailableInfo ? item.availableHours : 0
      this.setState({ dataDate: new Date() })

      item.scheduledHours += item.noHours - prevNoHours
      onChange(item.date, item.noHours)
    }

    if (onShowHour) {
      onShowHour(item, itemIdx)
    }
  }
}

export default PlannerDateRange
